module.exports = __webpack_public_path__ + "img/kx5200-7.b5fb6792.png";